<div
  class="flex flex-col items-center px-6 py-8 text-center"
  role="alert"
  aria-live="assertive"
>
  <mat-icon class="h-20! w-20! text-[80px]! text-green-500!" aria-hidden="true"
    >check_circle</mat-icon
  >

  @if (!order()) {
    <h2 class="font-lato mt-6 text-2xl font-bold text-[#1A1A1A]">
      Ticket Submitted!
    </h2>
    <p class="font-lato mt-3 text-base text-[#414141]">
      Your ticket has been created and sent. We'll keep you updated on the
      status as we proceed.
    </p>
  } @else {
    <h2 class="font-lato mt-6 text-2xl font-bold text-[#1A1A1A]">
      Order Submitted!
    </h2>
    @if (order().Id) {
      <p class="font-lato mt-3 text-base text-[#414141]">
        Your order
        <a
          class="text-brand-blue underline"
          routerLink="/orders/{{ order().Id }}"
          (click)="onClosed()"
          >{{ order().Name }}</a
        >
        has been created and sent. We'll keep you updated on the status as we
        proceed.
      </p>
    } @else {
      <p class="font-lato mt-3 text-base text-[#414141]">
        Your
        <a
          class="text-brand-blue underline"
          routerLink="/orders"
          (click)="onClosed()"
          >order</a
        >
        has been created and sent. We'll keep you updated on the status as we
        proceed.
      </p>
    }
  }

  @if (order()?.notificationSent === false) {
    <div class="mt-4 w-full">
      <app-banner-message
        status="warning"
        message="We couldn't send a confirmation email for this order. You can check its status anytime in Orders page."
      ></app-banner-message>
    </div>
  }

  <div class="mt-8 w-full">
    <button type="button" class="btn-primary w-full" (click)="onClosed()">
      Done
    </button>
  </div>
</div>
